// This reducer is developed so that it can be used by 1 component to update the store, without being dependent on it, and any
// other component can in turn listen to these updates. 

import { INSIGHTS_USAGE_CHART_ACTIONS } from "../../actions/insightsUsageV2Actions";

let defaultState = {
    usagePageDetectedAppliances : [],
}

const intermediateReducer = (state = Object.assign({}, defaultState), action) => {
    switch(action.type){
        case INSIGHTS_USAGE_CHART_ACTIONS.SET_DETECTED_APPLIANCES: {
            state = {
                ...state,
                ...action.payload
            }
        }
        break;
        default:
        break;
    }
    return state;
}

export default intermediateReducer;